import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, Tooltip } from "@mantine/core";
import { TbLogout } from "react-icons/tb";
import { HiBars3BottomLeft } from "react-icons/hi2";

import { EModal } from "../Modal/EModal";
import { EButton } from "../Button/EButton";

import { useAuth } from "../../../data-access";
import { AppContext } from "../../../../AppContext";
import { getUserRole, showToast } from "../../../../utils/utility";
import { matchRoute } from "../../../../utils/routeUtility";
import { BellIcon, CircleUser, InboxIcon, LogOut, User } from "lucide-react";

export function ETopbar() {
  const location = useLocation();
  const {
    token,
    refreshToken,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    role,
    user,
    handleLogout,
  } = useContext(AppContext);

  const { logout } = useAuth();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [logOutModalOpened, setLogOutModalOpened] = useState<boolean>(false);

  // API CALLS
  const performLogout = async () => {
    if (!token || !refreshToken) {
      handleLogout();
      setLogOutModalOpened(false);
      return;
    }

    setIsLoading(true);

    const payload = {
      accessToken: token,
      refreshToken: refreshToken,
    };

    const response = await logout(payload);

    if (response.isSuccess) {
      // console.log("Logged out successfully: ", response.data.data);
      handleLogout();
      setLogOutModalOpened(false);
    } else {
      if (response?.status === 400) {
        handleLogout();
        setLogOutModalOpened(false);
        return;
      }

      console.log("Error while logging out: ", response.error);
      showToast({
        type: "error",
        title: "Something went wrong"!,
        message: response.message,
      });
    }
    setIsLoading(false);
  };
  const getUser = JSON.parse(localStorage.getItem("user") || "{}");
  // console.log("getUser", getUser);
  
  // console.log("role", role?.[0]);
  return (
    <>
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center">
          <HiBars3BottomLeft
            size={24}
            className="cursor-pointer"
            onClick={() => setIsSidebarCollapsed((prev) => !prev)}
          />
          <p className="font-semibold ml-2 text-lg tracking-tight">
            PML Travel / Dashboard
          </p>
        </div>

        {/* <div className="flex items-center justify-between">
        <div className="px-4">
        </div>
        <div className="flex flex-row gap-2 items-center">
          <Tooltip
            withArrow
            position="left-start"
            label="Logout"
            transitionProps={{ transition: 'pop', duration: 300 }}
          >
            <div
              className="cursor-pointer"
              onClick={() => setLogOutModalOpened(true)}
            >
              <TbLogout size={20} />
            </div>
          </Tooltip>
        </div>
      </div> */}

        <div className="flex gap-3 items-center">
          <div className="">
            <p className="font-semibold">{getUser?.value?.firstName}</p>
            <p className="text-gray-400 lowercase first-letter:uppercase">{role?.[0]}</p>
          </div>
          <Menu shadow="md" width={150}>
            <Menu.Target>
              <div className="icon-link cursor-pointer">
                <div className="flex gap-2">
                  <p>
                    <CircleUser />
                  </p>
                </div>
              </div>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                leftSection={<User size={14} />}
                onClick={() => {
                  navigate("/profile/details");
                }}
              >
               My Profile
              </Menu.Item>
              <Menu.Item
                leftSection={<LogOut size={14} />}
                onClick={() => {
                  setLogOutModalOpened(true);
                }}
              >
                LogOut
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>

      {/* Logout Model */}
      <EModal
        opened={logOutModalOpened}
        onClose={() => setLogOutModalOpened(false)}
        title="Are you sure you want to logout?"
      >
        <div className="flex justify-end">
          <EButton
            size="sm"
            className="btn-light"
            loading={isLoading}
            onClick={performLogout}
          >
            Yes, Logout
          </EButton>
        </div>
      </EModal>
    </>
  );
}
